module.exports = __webpack_public_path__ + "static/media/play-button.1e82dbbd.svg";